import React from 'react'

const SubscriptionItemMaster = () => {
  return (
    <div>SubscriptionItemMaster</div>
  )
}

export default SubscriptionItemMaster